import React from 'react';
import PropTypes from 'prop-types';

const InstructionalForm = ({ form, instructions }) => (
  <div className="instructional-form">
    {form}
    <div className="instructional-form__instructions">{instructions}</div>
  </div>
);

InstructionalForm.propTypes = {
  form: PropTypes.node.isRequired,
  instructions: PropTypes.node.isRequired,
};
export default InstructionalForm;
